import { Box, OutlinedInput, styled, Typography } from '@mui/material';

export const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexGrow: 1,
}));

export const FormsAndHelperSectionContainerStyled = styled(Box)(
  ({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
    },
  })
);

export const FormsSectionStyled = styled(Box)(() => ({
  padding: '0 10%',
}));

export const LoginTitleStyled = styled(Typography)(({ theme }) => ({
  padding: `${theme.spacing(4)} 0`,
}));

export const OutlinedInputStyled = styled(OutlinedInput)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const HelpersSectionStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 50,
  marginTop: 20,
}));

export const FooterTextStyled = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(2),
}));
